module.exports = __webpack_public_path__ + "static/img/bg2.fed15424.png";